import { render } from "./SignOutView.vue?vue&type=template&id=8c658960&ts=true"
import script from "./SignOutView.vue?vue&type=script&lang=ts"
export * from "./SignOutView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__